import React, { useCallback, useEffect, useState } from "react";
import api from "utils/apiService";

import TableDemo from "components/TableDemo";
import { AdsColumns } from "data/AdsColumns";
import { useSearchParams } from "react-router-dom";
import CreateAds from "./components/CreateAds";

const Index = () => {
  const [ads, setAds] = useState({ data: [], pagination: { totalDocs: 0 } });

  const [loading, setLoading] = useState(true);

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page") || 1;
  const status = searchParams.get("status");
  const targetRole = searchParams.get("targetRole");

  const fetchData = useCallback(async () => {
    try {
      const params = new URLSearchParams();
      if (status) params.set("status", status);
      if (targetRole) params.set("targetRole", targetRole);
      const query = params.toString();
      const res = await api.get(`/ads${query ? `?${query}` : ""}`);
      if (res.error) {
        console.error("API Error:", res.error);
      } else {
        setAds({
          data: res?.data || [],
          pagination: res?.pagination || { totalDocs: 0 },
        });
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    } finally {
      setLoading(false);
    }
  }, [status, targetRole]);

  useEffect(() => {
    fetchData();
  }, [fetchData, page]);
  return (
    <section className="mt-3">
      <div className="mb-10">
        <TableDemo
          data={ads?.data}
          columns={AdsColumns(fetchData)}
          title="الاعلانات"
          totalCount={ads?.pagination?.totalDocs}
          loading={loading}
          extraComponent={<CreateAds refetch={fetchData} />}
        />
      </div>
    </section>
  );
};

export default Index;
